<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="text-center m-t-lg">
        <h1>Welcome in Inspinia Project with Angular 15 and Bootstrap 5</h1>
        <small>
          It is an application skeleton for a typical web app. You can use it to
          quickly bootstrap your webapp projects and dev environment.
        </small>
      </div>
    </div>
  </div>
</div>
